import { useCallback, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { ACTIVITIES, TRIGGERS } from "@/data/checkin";
import { logError } from "@/lib/log";

const merge = (base, extra) => [...base, ...extra.filter((c) => !base.some((a) => a.label === c.label))];

export function useCustomItems() {
  const [custom, setCustom] = useState([]);

  useEffect(() => {
    api.get("/items").then((r) => setCustom(r.data)).catch((e) => logError("Custom items load failed:", e));
  }, []);

  const items = useMemo(() => {
    const of = (cats) => custom.filter((c) => cats.includes(c.category)).map((c) => ({ icon: c.icon || "✨", label: c.name }));
    return { activities: merge(ACTIVITIES, of(["habit", "wellness"])), triggers: merge(TRIGGERS, of(["trigger"])) };
  }, [custom]);

  const saveItem = useCallback((category) => (name) =>
    api.post("/items", { name, category, icon: "✨" })
      .then((r) => setCustom((c) => [...c, r.data]))
      .catch((e) => logError("Custom item save failed:", e)), []);

  return { items, saveItem };
}
